import { useSyncExternalStore } from 'react';
import { currentLanguage, i18n, type Language } from '@/i18n';

function subscribe(onChange: () => void) {
  i18n.on('languageChanged', onChange);
  return () => i18n.off('languageChanged', onChange);
}

/** The current UI language; re-renders the caller when it changes. */
export function useLanguage(): Language {
  return useSyncExternalStore(subscribe, currentLanguage);
}
